import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MessageService } from 'src/services/message.service';
import { NotificationsService } from 'src/services/notifications.service';

@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  styleUrls: ['./add-notification.component.css']
})
export class AddNotificationComponent implements OnInit {

  columns: any[] = [{ name: "name", displayName: "Assigned Segments" }];
  notificationForm: FormGroup;
  availableSegmentList: any[] = [];
  segments: any[] = [];
  showEdit: boolean = false;
  viewNotification: boolean = false;
  showAdd: boolean = false;
  isReadOnly: boolean = false;
  listChanges: boolean;
  assignedSegmentList: any[] = [];
  notificationEdited: boolean = false;
  searchSegment: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddNotificationComponent>,
    private notificationService: NotificationsService,
    private msgService: MessageService
  ) { }

  ngOnInit() {
    this.notificationForm = new FormGroup({
      title: new FormControl(),
      message: new FormControl(),
      payload: new FormControl()
    });
    // edit notification view
    if (this.data.rec) {
      this.notificationForm.patchValue({
        title: this.data.rec.subject,
        message: this.data.rec.messageTpl,
        payload: this.data.rec.payloadTpl
      });
      // console.log(this.notificationForm.get("title").value);
      this.showEdit = true;
      this.showAdd = false;
      // just view notification details (no edit)
      if (this.data.rec.sentOn !== undefined) {
        this.viewNotification = true;
        this.isReadOnly = true;
        this.showEdit = false;
        this.showAdd = false;
        this.notificationForm.disable();
      }
    } else {
      this.showEdit = false;
      this.showAdd = true;
    }
    this.getSegments();
  }

  onTitleChange(event) {
    if (event.target.value) {
      this.notificationEdited = true;
    } else {
      this.notificationEdited = false;
    }
  }

  onMessageChange(event) {
    if (event.target.value) {
      this.notificationEdited = true;
    } else {
      this.notificationEdited = false;
    }
  }

  onPayloadChange(event) {
    if (event.target.value) {
      this.notificationEdited = true;
    } else {
      this.notificationEdited = false;
    }
  }

  getSegments() {
    this.notificationService.getSegmentsForNotifications().subscribe((response: any) => {
      this.availableSegmentList = response.data;
      // console.log(this.availableSegmentList,'segments');
      if (this.data.rec) {
        this.getAssignedSegmentList();
      }
      // console.log("response", response);
    }, err => {
      console.log('error', err);
    });
  }

  // get list of already assigned segments of notification for edit case
  getAssignedSegmentList() {
    this.notificationService.getNotificationAssignedSegmentsList(this.data.rec.id).subscribe(
      (result: any) => {
        this.assignedSegmentList = result;
        console.log('assigned', this.assignedSegmentList);
        this.removeAssignedSegmentsFromSegmentList();
      }, err => {
        console.error("get assigned users list server error");
      }
    );
  }

  removeAssignedSegmentsFromSegmentList() {
    this.availableSegmentList = this.availableSegmentList.filter(seg => {
      return this.assignedSegmentList.findIndex(assignedSeg => assignedSeg.id === seg.id) === -1;
    });
  }

  selectionChangesUpdate(event) {
    // console.log(event);
    this.availableSegmentList = event.availableList;
    this.assignedSegmentList = event.assignedList;
    this.listChanges = event.listChanges;
  }

  addNotification() {
    let selectedSegmentIds = [];
    this.assignedSegmentList.forEach(seg => {
      selectedSegmentIds.push(seg.id);
    });
    const payload = {
      subject: this.notificationForm.controls.title.value,
      messageTpl: this.notificationForm.controls.message.value,
      segments: selectedSegmentIds,
      payloadTpl: this.notificationForm.controls.payload.value,
      isActive: true,
    }
    this.notificationService.addNotification(payload).subscribe(
      (response: any) => {
        this.dialogRef.close('updated');
      }, err => {

      }
    );
  }

  editNotification() {
    let selectedSegmentIds = [];
    this.assignedSegmentList.forEach(seg => {
      selectedSegmentIds.push(seg.id);
    });
    let id = this.data.rec.id;
    const paylod = {
      subject: this.notificationForm.controls.title.value,
      messageTpl: this.notificationForm.controls.message.value,
      payloadTpl: this.notificationForm.controls.payload.value,
      segments: selectedSegmentIds,
    }
    // console.log(id,paylod,"edittt");

    this.notificationService.updateNotification(id, paylod).subscribe(
      (response: any) => {
        this.dialogRef.close('updated');
      }, err => {
        console.log('error', err);
      }
    );
  }

  applyFilter() {
    this.notificationService.getFilteredSegmentsForNotifications(this.searchSegment).subscribe((response: any) => {
      this.availableSegmentList = response.data;
      this.removeAssignedSegmentsFromSegmentList();
    });
  }

  clear() {
    this.searchSegment = "";
    this.applyFilter();
  }

  cancel() {
    this.dialogRef.close();
  }

}
